module.exports = "/_next/static/images/twitter-filled-icon-aceabc5c232eefd263e577c18f30d2a4.svg";